import { Modal, Box, Typography, FormControl, TextField, Button, useTheme, FormLabel, MenuItem, Select, Menu, Input } from "@mui/material";
import React, { useContext, useState } from "react";
import { AIVerificationResult } from "../../../api";
import { assetsApi, inspectionsApi } from "../../../api-interface";
import { TenantContext } from "../../..";
import { Link, useNavigate } from "react-router-dom";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useSnackbar } from "notistack";
import { yupResolver } from '@hookform/resolvers/yup';
import { get, useForm } from 'react-hook-form';
import * as yup from "yup"
import UnstyledLink from "../../../components/common/UnstyledLink/UnstyledLink";
import { red } from "@mui/material/colors";
import { reminderTypeLabels } from "../../../components/common/reminderTypeLabels";

const AddReminderModal = ({ open, handleClose, assetId }: { open: boolean, handleClose: () => void, assetId: string }) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        minWidth: 100,
        p: 4,
    };
    const theme = useTheme()
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const tenant = useContext(TenantContext)

    const schema = yup
        .object({
            type: yup.string().required('A reminder type is required'),
            date: yup
                .date()
                .required('A date is required')
                .transform((curr, orig) => orig === '' ? null : curr)
                .test(
                    'is-future',
                    'Date must be in the future',
                    value => value && new Date(value).setHours(0,0,0,0) > new Date().setHours(0,0,0,0)
                ),
            notes: yup.string().notRequired()
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        reset
    } = useForm({
        resolver: yupResolver(schema),
    })

        const handle = async (x) => {
        try {
            x.date = new Date(x.date).toISOString().split('T')[0];
            console.log(x)
            await assetsApi(tenant).createAssetReminderAssetsAssetIdRemindersPost(assetId, x.type, x.date, x.notes)
            enqueueSnackbar("Reminder Added", { variant: "success" })
            reset();
            navigate("")
            handleClose()
        } catch (e) {
            if (e?.response?.data?.detail) {
                enqueueSnackbar(e.response.data.detail, { variant: "error" })
            } else {
                enqueueSnackbar("Error: " + e, { variant: "error" })
            }
        }
    }

    const tenant_id = useContext(TenantContext)

    return <Modal
        open={open}
        onClose={() => {
            handleClose()
        }}
    >
        <Box sx={style} display="flex" flexDirection={"column"} gap={2}>
            <Typography variant="h6">Add Asset Reminder</Typography>
            <Box display="flex" flexDirection={"column"} gap={2}>
                <FormControl fullWidth>
                    <FormLabel>Reminder Type</FormLabel>
                    <Select
                        label="Reminder Type"
                        defaultValue=""
                        {...register("type")}
                        error={!!errors.type}
                    >
                        <MenuItem value="" disabled>Select Type</MenuItem>
                        {Object.entries(reminderTypeLabels).map(([value, label]) => (
                            <MenuItem key={value} value={value}>{label}</MenuItem>
                        ))}
                    </Select>
                    {errors.type && <Typography variant="body2" color={theme.palette.error.main}>{errors.type.message}</Typography>}
                </FormControl>
                <FormControl fullWidth>
                    <TextField
                        label="Reminder Date"
                        type="date"
                        {...register("date")}
                        slotProps={{
                            inputLabel: { shrink: true },
                        }}
                        sx={{ width: '100%' }}
                        error={!!errors.date}
                        helperText={errors.date && errors.date.message}
                    />
                </FormControl>
                <FormControl fullWidth>
                    <TextField
                        label="Notes"
                        multiline
                        rows={4}
                        {...register("notes")}
                        error={!!errors.notes}
                        helperText={errors.notes ? errors.notes.message : ''}
                    />
                </FormControl>
            </Box>
            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        reset();
                        handleClose()
                    }}
                >Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit(handle)}
                >Add Reminder</Button>
            </Box>
        </Box>
    </Modal>
}
export default AddReminderModal